import { z } from 'zod';
export const NotificationType = z.enum([
    'lead.created',
    'lead.assigned',
    'lead.replied',
    'lead.closed',
    'system.alert',
]);
export const Notification = z.object({
    id: z.string().uuid(),
    recipientSalesId: z.string().uuid().nullable(), // null = broadcast
    tenantId: z.string().uuid(),
    type: NotificationType,
    payloadJson: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    deliveredAt: z.string().datetime().nullable(),
    readAt: z.string().datetime().nullable(),
    ackedAt: z.string().datetime().nullable(),
});
export const ListNotificationsQuery = z.object({
    /** Return notifications with id > sinceId (cursor by surrogate id). */
    sinceId: z.string().uuid().optional(),
    limit: z.number().int().min(1).max(200).default(50),
    unreadOnly: z.boolean().optional(),
});
export const AckNotificationRequest = z.object({
    notificationIds: z.array(z.string().uuid()).min(1).max(100),
});
//# sourceMappingURL=notification.js.map